module.exports = __webpack_public_path__ + "static/icon_zb.99ee8615.svg";